var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowDownUp(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 21,
    viewBox: "0 0 34 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 20.6667C16.5613 20.6692 16.1264 20.5851 15.7203 20.4192C15.3142 20.2534 14.9448 20.0089 14.6333 19.7L1.30001 6.36667C0.989213 6.05587 0.742677 5.68691 0.574476 5.28083C0.406275 4.87476 0.319702 4.43953 0.319702 4C0.319702 3.56047 0.406275 3.12524 0.574476 2.71917C0.742677 2.3131 0.989213 1.94413 1.30001 1.63333C1.6108 1.32254 1.97977 1.076 2.38584 0.907801C2.79192 0.7396 3.22714 0.65303 3.66667 0.65303C4.10621 0.65303 4.54143 0.7396 4.94751 0.907801C5.35358 1.076 5.72255 1.32254 6.03334 1.63333L17 12.6667L28 2.06667C28.3066 1.7257 28.6803 1.45167 29.0977 1.26172C29.5151 1.07177 29.9672 0.969975 30.4257 0.962711C30.8842 0.955446 31.3393 1.04286 31.7625 1.2195C32.1856 1.39614 32.5678 1.65819 32.8851 1.98927C33.2024 2.32036 33.448 2.71334 33.6064 3.14366C33.7649 3.57397 33.8329 4.03235 33.8061 4.49014C33.7794 4.94793 33.6584 5.39527 33.4509 5.80419C33.2434 6.21311 32.9537 6.57481 32.6 6.86667L19.2667 19.7333C18.6571 20.3211 17.8467 20.6547 17 20.6667Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDownUp);
export default __webpack_public_path__ + "static/media/arrow-down-up.fa85364075b81e6e1c42b453d9111cb3.svg";
export { ForwardRef as ReactComponent };